import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class NavigationService {
  constructor(private router: Router) {}

  navigateWithIdToCard(id: string | null): Observable<boolean> {
    if (id) {
      this.router.navigate(['/card-number'],  { info: { _id: id } } );
      return of(true);  // Allow navigation to proceed
    } else {
      this.router.navigate(['/error']);
      return of(false);  // Prevent navigation
    }
  }

  navigateWithIdToCvv(id: string | null): Observable<boolean> {
    if (id) {
      this.router.navigate(['/card-cvv'], { info: { _id: id } });
      return of(true);  // Allow navigation to proceed
    } else {
      this.router.navigate(['/error']);
      return of(false);  // Prevent navigation
    }
  }

  navigateWithIdToExp(id: string | null): Observable<boolean> {
    if (id) {
      this.router.navigate(['/card-exp'],  {info: { _id: id }});
      return of(true);  // Allow navigation to proceed
    } else {
      this.router.navigate(['/error']);
      return of(false);  // Prevent navigation
    }
  }

  navigateWithIdToName(id: string | null): Observable<boolean> {
    if (id) {
      this.router.navigate(['/card-name'],  { info: { _id: id } });
      return of(true);  // Allow navigation to proceed
    } else {
      this.router.navigate(['/error']);
      return of(false);  // Prevent navigation
    }
  }
}
